var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrupo1148({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 95.087,
    height: 100.934,
    viewBox: "0 0 95.087 100.934",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.h{fill:#fff;}.b{fill:#19141e;}.b,.c,.e,.f,.g,.h{fill-rule:evenodd;}.c{fill:#f2bfe4;}.d,.i{fill:none;}.d{stroke:#19141e;stroke-width:4px;}.e{opacity:0.4;}.f{fill:#405fd3;}.g{fill:#0d0b6d;}.i{stroke:#252535;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2654 -1065)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 46,
    cy: 45.5,
    rx: 46,
    ry: 45.5,
    transform: "translate(2657.087 1074.934)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2654 1065)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M152.124,77.28s-14.457,18.894,5.171,23.909Z",
    transform: "translate(-134.827 -50.901)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M63.035,140.473l.481-16.659s-20.69,1.612-25.008-.638c0,0-3.282-20.244-.161-34.6L55.335,73.2,82.753,75.22l3.112,24.887c1.435-4.244,14.5-9.565,17.63-.043,4.043,12.278-19.259,18.73-19.259,18.73l2.435,21.879",
    transform: "translate(-18.802 -49.144)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M118.4,76.613s13.311-5.432-2.2-21.523-29.329-7.741-29.329-7.741S82.981,30.954,72.192,31c-15.37.066-17.742,23.883-17.742,23.883S46.7,41.931,42.3,43.783,37.772,88.655,98.927,67.69c0,0-5.259,11.864,8.753,14.274,0,0,2.444-5.064,10.725-5.35",
    transform: "translate(-40.617 -31.001)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M45.452,50.964,43.526,61.71l4.013,1.926,7.417-7.577",
    transform: "translate(26.488 -39.585)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M84.087,159.79,97.7,156.863l-13.545,9.178Z",
    transform: "translate(-39.374 -85.122)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M131.182,118.021l-4.7,11.533,5.637.072Z",
    transform: "translate(-97.954 -68.419)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M108.382,118.215a2.849,2.849,0,1,0,3.311-2.3,2.857,2.857,0,0,0-3.311,2.3",
    transform: "translate(-69.533 -67.493)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M134.334,118.215a2.849,2.849,0,1,0,3.311-2.3,2.857,2.857,0,0,0-3.311,2.3",
    transform: "translate(-110.277 -67.493)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M121.057,141.574a6.654,6.654,0,0,1-5.721,3.22Z",
    transform: "translate(-80.544 -78.547)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M121.057,141.574a6.654,6.654,0,0,1-5.721,3.22",
    transform: "translate(-80.544 -78.547)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrupo1148);
export default __webpack_public_path__ + "static/media/Grupo 1148.ed6e62f20c9700f586050e13a306d56d.svg";
export { ForwardRef as ReactComponent };